import React from 'react';
import { useSelector } from 'react-redux';

import { MenuItem, TextField, Typography } from '@mui/material';

import { LocaleField } from 'common/types';
import { useTranslation } from 'services/localization/useTranslation';

import * as ShopSelectors from 'selectors/ShopSelectors';
import * as RentalViewSelectors from 'selectors/RentalViewSelectors';
import { getUniqueCarrierOptions } from './utils';

interface Props {
	value: string | null;
	onChange: (carrierId: string) => void;
	oldCarrier?: {
		id: string;
		name: LocaleField;
	};
}

const CarrierSelect = (props: Props) => {
	const { value, onChange, oldCarrier } = props;
	const { t, getTranslation } = useTranslation();

	const shopCarriers = useSelector(ShopSelectors.activeShopCarriers);
	const orderInfo = useSelector(RentalViewSelectors.orderInfo)!;

	const activeLocationCarrier = shopCarriers.filter((carriers) =>
		carriers.locationIds.includes(orderInfo?.startLocation.id),
	);

	const carrierOptions = getUniqueCarrierOptions(activeLocationCarrier, oldCarrier);

	const handleCarrierChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		onChange(e.target.value);
	};

	return (
		<TextField
			select
			value={value}
			onChange={handleCarrierChange}
			variant="outlined"
			label={t('delivery.carrier', 'Carrier')}
			fullWidth
			size="small"
			SelectProps={{ displayEmpty: true }}
			InputLabelProps={{ shrink: true }}
		>
			<MenuItem value="">
				<Typography variant="body1" color="textSecondary">
					{t('delivery.selectCarrier', 'Select carrier')}
				</Typography>
			</MenuItem>
			{carrierOptions.map((carrier) => (
				<MenuItem key={carrier.id} value={carrier.id}>
					<Typography variant="body1">{getTranslation(carrier.name)}</Typography>
				</MenuItem>
			))}
		</TextField>
	);
};

export default CarrierSelect;
